import { useState, ReactElement, useEffect } from 'react';
import { useIntl } from 'react-intl';
import messages from '../locales/messages';
import 'src/common/style/common.scss';
import { ThanksModal, thanksTable } from 'src/common/utils/ThanksModal';

export interface thanksProps {
  industry: string;
  estimatedAnnualSale: number;
  onlineSalePercentage: number;
  industryAvgProfit: number;
  avgMarkDownCost: number;
  avgShippingCost: number;
  increaseOnlineSalesTotal: string;
  increaseStoreSalesTotal: string;
  bpName: string;
  reduceReturnsTotal: string;
  reduceMarkDownCostTotal: string;
  reduceShippingCostTotal: string;
  switchValue: string;
  increaseInSaleTotal: string;
  reductionInCostsTotal: string;
  additionalProfitTotal: string;
  estimatedSavings: string;
}

const Thanks = ({
  industry,
  estimatedAnnualSale,
  onlineSalePercentage,
  industryAvgProfit,
  avgMarkDownCost,
  avgShippingCost,
  increaseOnlineSalesTotal,
  increaseStoreSalesTotal,
  reduceReturnsTotal,
  reduceMarkDownCostTotal,
  reduceShippingCostTotal,
  switchValue,
  increaseInSaleTotal,
  reductionInCostsTotal,
  additionalProfitTotal,
  estimatedSavings,
  bpName,
}: thanksProps): ReactElement => {
  const intl = useIntl();
  const [, setShowThanksModal] = useState(true);
  const titleThanks: thanksTable[] = [
    { group: 'title', value: intl.formatMessage(messages.thankYouTitle) },
    {
      group: 'subTitle',
      value: intl.formatMessage(messages.thankYouSubTitle),
    },
  ];

  const widgetTitleThanks: thanksTable[] = [
    {
      group: 'widgetTitle1',
      value: intl.formatMessage(messages.thankYouDetailsTitle),
    },
  ];

  const contentThanks: thanksTable[] = [
    {
      group: String(intl.formatMessage(messages.industry_label)),
      value: industry,
    },
    {
      group: String(intl.formatMessage(messages.inputField_txt)),
      value: String(estimatedAnnualSale),
    },
    {
      group: String(intl.formatMessage(messages.slider1_txt)),
      value: String(onlineSalePercentage),
    },
    {
      group: String(intl.formatMessage(messages.slider2_txt)),
      value: String(industryAvgProfit),
    },
    {
      group: String(intl.formatMessage(messages.slider3_txt)),
      value: String(avgMarkDownCost),
    },
    {
      group: String(intl.formatMessage(messages.slider4_txt)),
      value: String(avgShippingCost),
    },
    {
      group: String(intl.formatMessage(messages.catg1_text)),
      value: String(increaseOnlineSalesTotal),
    },
    {
      group: String(intl.formatMessage(messages.catg2_text)),
      value: String(increaseStoreSalesTotal),
    },
    {
      group: String(intl.formatMessage(messages.catg3_text)),
      value: String(reduceReturnsTotal),
    },
    {
      group: String(intl.formatMessage(messages.catg4_text)),
      value: String(reduceMarkDownCostTotal),
    },
    {
      group: String(intl.formatMessage(messages.catg5_text)),
      value: String(reduceShippingCostTotal),
    },
    {
      group: String(intl.formatMessage(messages.switch_label)),
      value: String(switchValue),
    },
    {
      group: String(intl.formatMessage(messages.increase_sale_text)),
      value: String(increaseInSaleTotal),
    },
    {
      group: String(intl.formatMessage(messages.reduction_cost_text)),
      value: String(reductionInCostsTotal),
    },
    {
      group: String(intl.formatMessage(messages.additional_profit)),
      value: String(additionalProfitTotal),
    },
    {
      group: String(intl.formatMessage(messages.estimatedTotal)),
      value: String(estimatedSavings),
    },
  ];

  bpName &&
    contentThanks.push({
      group: String(intl.formatMessage(messages.bp_title)),
      value: bpName,
    });

  const buttonThanks: thanksTable[] = [
    {
      group: 'button1',
      value: String(intl.formatMessage(messages.return_est_text)),
    },
  ];

  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    setShowModal(true);
  }, [
    industry,
    estimatedAnnualSale,
    onlineSalePercentage,
    industryAvgProfit,
    avgMarkDownCost,
    avgShippingCost,
    switchValue,
    increaseInSaleTotal,
    reductionInCostsTotal,
    additionalProfitTotal,
    estimatedSavings,
  ]);
  return (
    <ThanksModal
      showThanksModal={showModal}
      pageTitle="Sterling SIP ROI/BVA Benefits Page"
      object="Pricing Page"
      productTitle={'Sterling SIP ROI/BVA Benefits Estimator'}
      pageUrl={'/products/intelligent-promising/pricing/'}
      location={'Estimator'}
      titleThanks={titleThanks}
      widgetTitleThanks={widgetTitleThanks}
      contentThanks={contentThanks}
      buttonThanks={buttonThanks}
      setShowThanksModal={setShowThanksModal}
    />
  );
};

export default Thanks;
